import React, { Component } from "react";
import GravityForm from "react-gravity-form";
import WithConsumer from '../../context/WithConsumer';
import { Link } from 'react-router-dom';

export default class Enquire extends Component {
	
	constructor(){
		super()
		this.handleToggle 		= this.handleToggle.bind(this);
	}
    
    handleToggle() {  
		document.body.classList.remove('state-enquire-open');
	    document.body.classList.remove('state-menu-open');
    }
    
	render () {
		
	    return (
		    
		    <div className="c-enquire">
		    
		    	<a href="#" className="c-enquire__close-button" onClick={(e) => (e.preventDefault(), this.handleToggle())}><span>Close</span></a>
		    	
		    	<div className="c-enquire__inner">
		    											
					<div className="scope-form">
						<GravityForm
							backendUrl={document.location.origin + '/wp-json/vestbuild/v1/form'}
							formID={11}
						/>
					</div>
												
				</div>
		    
		    </div>
		)

	}
}
